"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setOutput = exports.asyncForEach = exports.getInputList = exports.getArgs = exports.getInputs = exports.tmpNameSync = exports.tmpDir = exports.defaultContext = void 0;
const sync_1 = __importDefault(require("csv-parse/lib/sync"));
const fs = __importStar(require("fs"));
const os = __importStar(require("os"));
const path = __importStar(require("path"));
const tmp = __importStar(require("tmp"));
const core = __importStar(require("@actions/core"));
const command_1 = require("@actions/core/lib/command");
const github = __importStar(require("@actions/github"));
const buildx = __importStar(require("./buildx"));
const handlebars = __importStar(require("handlebars"));
let _defaultContext, _tmpDir;
function defaultContext() {
    if (!_defaultContext) {
        let ref = github.context.ref;
        if (github.context.sha && ref && !ref.startsWith('refs/')) {
            ref = `refs/heads/${github.context.ref}`;
        }
        if (github.context.sha && !ref.startsWith(`refs/pull/`)) {
            ref = github.context.sha;
        }
        _defaultContext = `${process.env.GITHUB_SERVER_URL || 'https://github.com'}/${github.context.repo.owner}/${github.context.repo.repo}.git#${ref}`;
    }
    return _defaultContext;
}
exports.defaultContext = defaultContext;
function tmpDir() {
    if (!_tmpDir) {
        _tmpDir = fs.mkdtempSync(path.join(os.tmpdir(), 'docker-build-push-')).split(path.sep).join(path.posix.sep);
    }
    return _tmpDir;
}
exports.tmpDir = tmpDir;
function tmpNameSync(options) {
    return tmp.tmpNameSync(options);
}
exports.tmpNameSync = tmpNameSync;
function getInputs(defaultContext) {
    return __awaiter(this, void 0, void 0, function* () {
        return {
            addHosts: yield getInputList('add-hosts'),
            allow: yield getInputList('allow'),
            buildArgs: yield getInputList('build-args', true),
            buildContexts: yield getInputList('build-contexts', true),
            builder: core.getInput('builder'),
            cacheFrom: yield getInputList('cache-from', true),
            cacheTo: yield getInputList('cache-to', true),
            cgroupParent: core.getInput('cgroup-parent'),
            context: core.getInput('context') || defaultContext,
            file: core.getInput('file'),
            labels: yield getInputList('labels', true),
            load: core.getBooleanInput('load'),
            network: core.getInput('network'),
            noCache: core.getBooleanInput('no-cache'),
            outputs: yield getInputList('outputs', true),
            platforms: yield getInputList('platforms'),
            pull: core.getBooleanInput('pull'),
            push: core.getBooleanInput('push'),
            secrets: yield getInputList('secrets', true),
            secretFiles: yield getInputList('secret-files', true),
            shmSize: core.getInput('shm-size'),
            ssh: yield getInputList('ssh'),
            tags: yield getInputList('tags'),
            target: core.getInput('target'),
            ulimit: yield getInputList('ulimit', true),
            githubToken: core.getInput('github-token')
        };
    });
}
exports.getInputs = getInputs;
function getArgs(inputs, defaultContext, buildxVersion) {
    return __awaiter(this, void 0, void 0, function* () {
        // prettier-ignore
        return [
            'buildx',
            ...yield getBuildArgs(inputs, defaultContext, buildxVersion),
            ...yield getCommonArgs(inputs, buildxVersion),
            handlebars.compile(inputs.context)({ defaultContext })
        ];
    });
}
exports.getArgs = getArgs;
function getBuildArgs(inputs, defaultContext, buildxVersion) {
    return __awaiter(this, void 0, void 0, function* () {
        const args = ['build'];
        yield (0, exports.asyncForEach)(inputs.addHosts, (addHost) => __awaiter(this, void 0, void 0, function* () {
            args.push('--add-host', addHost);
        }));
        if (inputs.allow.length > 0) {
            args.push('--allow', inputs.allow.join(','));
        }
        yield (0, exports.asyncForEach)(inputs.buildArgs, (buildArg) => __awaiter(this, void 0, void 0, function* () {
            args.push('--build-arg', buildArg);
        }));
        if (buildx.satisfies(buildxVersion, '>=0.8.0')) {
            yield (0, exports.asyncForEach)(inputs.buildContexts, (buildContext) => __awaiter(this, void 0, void 0, function* () {
                args.push('--build-context', buildContext);
            }));
        }
        yield (0, exports.asyncForEach)(inputs.cacheFrom, (cacheFrom) => __awaiter(this, void 0, void 0, function* () {
            args.push('--cache-from', cacheFrom);
        }));
        yield (0, exports.asyncForEach)(inputs.cacheTo, (cacheTo) => __awaiter(this, void 0, void 0, function* () {
            args.push('--cache-to', cacheTo);
        }));
        if (inputs.cgroupParent) {
            args.push('--cgroup-parent', inputs.cgroupParent);
        }
        if (inputs.file) {
            args.push('--file', inputs.file);
        }
        if (!buildx.isLocalOrTarExporter(inputs.outputs) && (inputs.platforms.length == 0 || buildx.satisfies(buildxVersion, '>=0.4.2'))) {
            args.push('--iidfile', yield buildx.getImageIDFile());
        }
        yield (0, exports.asyncForEach)(inputs.labels, (label) => __awaiter(this, void 0, void 0, function* () {
            args.push('--label', label);
        }));
        yield (0, exports.asyncForEach)(inputs.outputs, (output) => __awaiter(this, void 0, void 0, function* () {
            args.push('--output', output);
        }));
        if (inputs.platforms.length > 0) {
            args.push('--platform', inputs.platforms.join(','));
        }
        yield (0, exports.asyncForEach)(inputs.secrets, (secret) => __awaiter(this, void 0, void 0, function* () {
            try {
                args.push('--secret', yield buildx.getSecretString(secret));
            }
            catch (err) {
                core.warning(err.message);
            }
        }));
        yield (0, exports.asyncForEach)(inputs.secretFiles, (secretFile) => __awaiter(this, void 0, void 0, function* () {
            try {
                args.push('--secret', yield buildx.getSecretFile(secretFile));
            }
            catch (err) {
                core.warning(err.message);
            }
        }));
        if (inputs.githubToken && !buildx.hasGitAuthToken(inputs.secrets) && inputs.context == defaultContext) {
            args.push('--secret', yield buildx.getSecretString(`GIT_AUTH_TOKEN=${inputs.githubToken}`));
        }
        if (inputs.shmSize) {
            args.push('--shm-size', inputs.shmSize);
        }
        yield (0, exports.asyncForEach)(inputs.ssh, (ssh) => __awaiter(this, void 0, void 0, function* () {
            args.push('--ssh', ssh);
        }));
        yield (0, exports.asyncForEach)(inputs.tags, (tag) => __awaiter(this, void 0, void 0, function* () {
            args.push('--tag', tag);
        }));
        if (inputs.target) {
            args.push('--target', inputs.target);
        }
        yield (0, exports.asyncForEach)(inputs.ulimit, (ulimit) => __awaiter(this, void 0, void 0, function* () {
            args.push('--ulimit', ulimit);
        }));
        return args;
    });
}
function getCommonArgs(inputs, buildxVersion) {
    return __awaiter(this, void 0, void 0, function* () {
        const args = [];
        if (inputs.builder) {
            args.push('--builder', inputs.builder);
        }
        if (inputs.load) {
            args.push('--load');
        }
        if (buildx.satisfies(buildxVersion, '>=0.6.0')) {
            args.push('--metadata-file', yield buildx.getMetadataFile());
        }
        if (inputs.network) {
            args.push('--network', inputs.network);
        }
        if (inputs.noCache) {
            args.push('--no-cache');
        }
        if (inputs.pull) {
            args.push('--pull');
        }
        if (inputs.push) {
            args.push('--push');
        }
        return args;
    });
}
function getInputList(name, ignoreComma) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = [];
        const items = core.getInput(name);
        if (items == '') {
            return res;
        }
        for (const output of (yield (0, sync_1.default)(items, {
            columns: false,
            relax: true,
            relaxColumnCount: true,
            skipLinesWithEmptyValues: true
        }))) {
            if (output.length == 1) {
                res.push(output[0]);
                continue;
            }
            else if (!ignoreComma) {
                res.push(...output);
                continue;
            }
            res.push(output.join(','));
        }
        return res.filter(item => item).map(pat => pat.trim());
    });
}
exports.getInputList = getInputList;
const asyncForEach = (array, callback) => __awaiter(void 0, void 0, void 0, function* () {
    for (let index = 0; index < array.length; index++) {
        yield callback(array[index], index, array);
    }
});
exports.asyncForEach = asyncForEach;
// FIXME: Temp fix https://github.com/actions/toolkit/issues/777
function setOutput(name, value) {
    (0, command_1.issueCommand)('set-output', { name }, value);
}
exports.setOutput = setOutput;
